
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { isDesktop } from '@/helpers/isDesktop';
import { Action, Getter } from 'vuex-class';
import type { DynamicField } from '@/models/dynamicField';

@Component({
    name: 'FormDynamicFieldMultiselect',
})
export default class FormDynamicFieldMultiselect extends Vue {
    @Model('input', {
        required: true,
    })
    private modelDynamicFields: DynamicField[];

    @Prop({
        required: false,
        default: () => [],
    })
    private availableDynamicFields: DynamicField[];

    // @Prop({
    //     required: false,
    // })
    // private counts;

    private defaultDynamicFields: DynamicField[] = [];

    private isDesktop = isDesktop();

    @Getter('company/dynamicFields') private dynamicFields: DynamicField[];
    @Action('company/fetchAllDynamicFields') private fetchAllDynamicFields: any;

    mounted() {
        if (this.availableDynamicFields.length === 0) {
            this.loadOptions();
        }
    }

    loadOptions() {
        this.fetchAllDynamicFields();

        this.defaultDynamicFields = this.dynamicFields;
    }

    // getCount(id) {
    //     const count = this.counts.find((x) => x.id === id);
    //     return count ? count.count : 0;
    // }

    get selected() {
        // if (this.counts.length === 0) {
        //     return this.modelDynamicFields;
        // }
        // return this.modelDynamicFields.filter((dynamicField) => this.getCount(dynamicField.id) > 0);
        return this.modelDynamicFields;
    }

    get available() {
        return this.availableDynamicFields.length > 0 ? this.availableDynamicFields : this.defaultDynamicFields;
    }
}
